import { useCallback } from "react";
import { useHandleCellClick } from "@/hooks/useHandleCellClick";

export const useCellClickHandler = (
	tileId: string,
	onTickerSelect?: (ticker: string) => void,
) => {
	const handleOnCellClick = useHandleCellClick({
		tileId,
		onTickerSelect,
	});

	const onCellClick = useCallback(
		(
			context: Parameters<typeof handleOnCellClick>[0],
			event: React.MouseEvent,
		) => {
			const target = event.target as HTMLElement;
			if (
				!(
					context.column.field.toLowerCase() === "ticker" &&
					target.nodeName.toLowerCase() !== "div"
				)
			) {
				handleOnCellClick(context, event);
			}
		},
		[handleOnCellClick],
	);

	return onCellClick;
};
